import { render, staticRenderFns } from "./OrgOnboardingStep1.vue?vue&type=template&id=4cb798f0&scoped=true"
import script from "./OrgOnboardingStep1.vue?vue&type=script&lang=js"
export * from "./OrgOnboardingStep1.vue?vue&type=script&lang=js"
import style0 from "./OrgOnboardingStep1.vue?vue&type=style&index=0&id=4cb798f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb798f0",
  null
  
)

export default component.exports